import defaultApi from '@/utils/request';

export default {
  ImportStudent(data) {
    return defaultApi({
      method: 'post',
      url: 'Import/ImportStudent',
      data,
    });
  },
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 'Import/Load',
      params,
    });
  },
};
